import { formatQtyWithUnit } from "@/modules/products/domain/unit-conversion";
import type { ProductPerformanceRowDTO } from "@/modules/reports/domain/types";

/** ສະແດງຈຳນວນຂາຍ + ແຖມ (ຫນ່ວຍຂາຍ) */
export function formatProductQuantity(row: ProductPerformanceRowDTO): string {
  const sold = formatQtyWithUnit(row.quantity, row.stockUnitLabel);
  if (row.bonusQuantity > 0) {
    return `${sold} (+${formatQtyWithUnit(row.bonusQuantity, row.stockUnitLabel)} ແຖມ)`;
  }
  return sold;
}
